<template>
  <v-container v-if="personal" fluid>
    <v-row>
      <v-col cols="4">
        <v-btn text class="mx-2" v-on:click="$router.go(-1)"
          ><v-icon>mdi-arrow-left</v-icon> Volver a catálogo de personal</v-btn
        >
      </v-col>
      <v-col cols="8" align="right">
        <v-spacer></v-spacer>
        <v-btn
          v-on:click="download(personal.foto)"
          rounded
          color="secondary"
          class="mx-2"
          v-if="personal.foto.length > 0"
          >Descargar fotografía</v-btn
        >
      </v-col>
      <v-col cols="3">
        <v-row>
          <v-col cols="12">
            <personal-card-component :personal="personal" :enrolamiento="enrolamiento[0]"></personal-card-component>
          </v-col>
          <v-col cols="12">
            <menu-list-component :loading="loadingPersonalData" :estatus="personal.fk_idEstatus"></menu-list-component>
          </v-col>
        </v-row>
      </v-col>
      <template v-if="loadingPersonalData == false">
        <v-col cols="9">
          <datos-generales-component
            v-if="selectedMenu == 1"
            :personal="personal"
            :estudios="estudiosPersonal"
          ></datos-generales-component>
          <referencias-component
            v-if="selectedMenu == 2"
            :personal="personal"
            :referencias="referencias"
            :familiares="familiares"
          ></referencias-component>
          <documentos-component
            v-if="selectedMenu == 3"
            :documentos="documentos"
            :id="personal.idPersonal"
          ></documentos-component>
          <desarrollo-elemento-component
            v-if="selectedMenu == 4"
            :evaluaciones="evaluacionesMedicas"
            :dictamenes="dictamenes"
            :biometricos="biometricosPersonal"
            :cursos="cursos"
            :evaluaciones-productividad="evaluacionesPersonalProductividad"
            :armas="armasPersonal"
            :equipamiento="equipamientoPersonal"
            :estatus="personal.fk_idEstatus"
          ></desarrollo-elemento-component>
          <puesto-dependencia-component v-if="selectedMenu == 5" :personal="personal"></puesto-dependencia-component>
          <area-adscripcion-component v-if="selectedMenu == 6" :personal="personal"></area-adscripcion-component>
          <faltas-administrativas-component
            v-if="selectedMenu == 8"
            :faltas="faltasAdministrativas"
          ></faltas-administrativas-component>
          <linea-tiempo-component v-if="selectedMenu == 7" :permutaciones="permutaciones"></linea-tiempo-component>
          <media-filiacion-component
            v-if="selectedMenu == 9"
            :media-filiacion="personal.mediafiliacion"
            :senias-particulares="personal.seniasParticulares"
            :personal="personal"
          ></media-filiacion-component>
          <CarreraPolicialComponent
            v-if="selectedMenu == 11"
            :convocatorias="convocatorias"
            :condecoraciones="condecoraciones"
            :personal="personal"
          />
          <LocsPersonalMainContainer v-if="selectedMenu == 13" :id-personal="personal.idPersonal" />
        </v-col>
      </template>
      <template v-else>
        <v-col cols="9">
          <v-skeleton-loader type="image" height="100%"></v-skeleton-loader>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<style scoped>
/* Estilos modernos para Expediente Personal - Módulo Enlace */
.selectable {
  cursor: pointer;
}

/* Cards generales - solo para el contenido principal, no el menu */
::v-deep .v-col:not(:first-child) .v-card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(69, 170, 242, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-col:not(:first-child) .v-card:hover {
  border-color: rgba(69, 170, 242, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(69, 170, 242, 0.3) !important;
}

/* Card title */
::v-deep .v-card-title {
  padding: 16px;
  background: rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

/* Card text */
::v-deep .v-card-text {
  padding: 16px;
}

/* Card actions */
::v-deep .v-card-actions {
  padding: 12px 16px !important;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}

/* Botones de navegación */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 24px rgba(69, 170, 242, 0.6) !important;
}

::v-deep .v-btn[color='secondary'],
::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #45aaf2 0%, #4b7bec 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(69, 170, 242, 0.4) !important;
  border: 2px solid rgba(69, 170, 242, 0.3) !important;
}

::v-deep .v-btn[color='secondary']:hover,
::v-deep .v-btn.secondary:hover {
  background: linear-gradient(135deg, #4b7bec 0%, #45aaf2 100%) !important;
  border-color: #45aaf2 !important;
  color: #ffffff !important;
}

::v-deep .v-btn.v-btn--text {
  color: #e0e0e0 !important;
  background: transparent !important;
}

::v-deep .v-btn.v-btn--text .v-icon {
  color: #e0e0e0 !important;
}

::v-deep .v-btn.v-btn--text:hover {
  background: rgba(69, 170, 242, 0.15) !important;
  color: #45aaf2 !important;
}

::v-deep .v-btn.v-btn--text:hover .v-icon {
  color: #45aaf2 !important;
}

::v-deep .v-btn.primary,
::v-deep .v-btn[color='primary'] {
  background: linear-gradient(135deg, #1a262e 0%, #0f1a1f 100%) !important;
  color: #45aaf2 !important;
  border: 2px solid rgba(69, 170, 242, 0.4) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}

::v-deep .v-btn.primary:hover,
::v-deep .v-btn[color='primary']:hover {
  background: linear-gradient(135deg, #0f1a1f 0%, #050a0f 100%) !important;
  border-color: #45aaf2 !important;
  color: #4b7bec !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.15);
}

/* Skeleton loader */
::v-deep .v-skeleton-loader {
  background: rgba(26, 42, 46, 0.4) !important;
  backdrop-filter: blur(10px);
  border-radius: 20px;
  border: 1px solid rgba(69, 170, 242, 0.1);
  pointer-events: none;
}

::v-deep .v-skeleton-loader__bone {
  background: linear-gradient(
    90deg,
    rgba(69, 170, 242, 0.05) 0%,
    rgba(69, 170, 242, 0.15) 50%,
    rgba(69, 170, 242, 0.05) 100%
  ) !important;
}

/* Container */
::v-deep .v-container {
  animation: fadeInUp 0.6s ease-out;
}

/* Rows y Cols con animación */
::v-deep .v-row {
  animation: fadeIn 0.5s ease-out;
}

/* Títulos y textos */
::v-deep .text-h6,
::v-deep .text-h5,
::v-deep .text-h4 {
  color: #e0e0e0 !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

::v-deep .text-subtitle-1,
::v-deep .text-subtitle-2 {
  color: rgba(224, 224, 224, 0.8) !important;
}

::v-deep .text-caption {
  color: rgba(224, 224, 224, 0.6) !important;
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid rgba(69, 170, 242, 0.4);
  transition: all 0.3s ease;
  background: rgba(26, 38, 46, 0.8) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

::v-deep .v-avatar:hover {
  border-color: #45aaf2;
  box-shadow: 0 8px 24px rgba(69, 170, 242, 0.5);
  transform: scale(1.05);
}

/* Imágenes */
::v-deep .v-image {
  border-radius: 8px;
  border: 2px solid rgba(69, 170, 242, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-image:hover {
  border-color: #45aaf2;
  transform: scale(1.02);
  box-shadow: 0 8px 24px rgba(69, 170, 242, 0.4);
}

/* Input fields */
::v-deep .v-text-field .v-input__slot {
  background: transparent !important;
  border: 1px solid rgba(69, 170, 242, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field .v-input__slot:hover {
  border-color: rgba(69, 170, 242, 0.3) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: #45aaf2 !important;
  box-shadow: 0 0 0 2px rgba(69, 170, 242, 0.1) !important;
  background: transparent !important;
}

::v-deep .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field__slot label {
  color: rgba(224, 224, 224, 0.6) !important;
}

::v-deep .v-input--is-focused .v-text-field__slot label {
  color: #45aaf2 !important;
}

/* Select y Autocomplete */
::v-deep .v-select .v-input__slot,
::v-deep .v-autocomplete .v-input__slot {
  background: transparent !important;
  border: 1px solid rgba(69, 170, 242, 0.2) !important;
  border-radius: 12px !important;
}

::v-deep .v-select:hover .v-input__slot,
::v-deep .v-autocomplete:hover .v-input__slot {
  border-color: rgba(69, 170, 242, 0.3) !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 38, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(69, 170, 242, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}

/* Tabs */
::v-deep .v-tabs {
  background: transparent !important;
}

::v-deep .v-tab {
  color: rgba(224, 224, 224, 0.7) !important;
  transition: all 0.3s ease;
  text-transform: none !important;
  font-weight: 500;
}

::v-deep .v-tab:hover {
  color: #45aaf2 !important;
  background: rgba(69, 170, 242, 0.1) !important;
}

::v-deep .v-tab--active {
  color: #45aaf2 !important;
}

::v-deep .v-tabs-slider {
  background-color: #45aaf2 !important;
  height: 3px;
  border-radius: 3px;
}

/* Dividers */
::v-deep .v-divider {
  border-color: rgba(69, 170, 242, 0.2) !important;
}

/* Chips */
::v-deep .v-chip {
  background: rgba(69, 170, 242, 0.2) !important;
  border: 1px solid rgba(69, 170, 242, 0.4);
  border-radius: 8px;
  color: #45aaf2 !important;
  transition: all 0.3s ease;
}

::v-deep .v-chip:hover {
  background: rgba(69, 170, 242, 0.3) !important;
  border-color: #45aaf2;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(69, 170, 242, 0.3);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(69, 170, 242, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(69, 170, 242, 0.6);
}

/* Animaciones */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Efectos de resplandor para elementos interactivos */
::v-deep .v-card:hover,
::v-deep .v-btn:hover {
  box-shadow: 0 0 20px rgba(69, 170, 242, 0.2), 0 8px 32px rgba(0, 0, 0, 0.4) !important;
}

/* Listas */
::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-list-item {
  transition: all 0.3s ease;
  border-radius: 8px;
  margin: 4px 0;
}

::v-deep .v-list-item:hover {
  background: rgba(69, 170, 242, 0.1) !important;
  transform: translateX(4px);
}

::v-deep .v-list-item--active {
  background: rgba(69, 170, 242, 0.2) !important;
  border-left: 3px solid #45aaf2;
}
</style>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import PersonalCardComponent from '../../components/expediente/PersonalCardComponent.vue'
import MenuListComponent from '../../components/expediente/MenuListComponent.vue'
import DatosGeneralesComponent from '../../components/expediente/DatosGeneralesComponent.vue'
import DocumentosComponent from '../../components/expediente/DocumentosComponent.vue'
import DesarrolloElementoComponent from '../../components/expediente/DesarrolloElemento.vue'
import AreaAdscripcionComponent from '../../components/expediente/AreaAdscripcionComponent.vue'
import ReferenciasComponent from '../../components/expediente/ReferenciasComponent.vue'
import PuestoDependenciaComponent from '../../components/expediente/PuestoDependenciaComponent'
import FaltasAdministrativasComponent from '../../components/expediente/FaltasAdministrativasComponent.vue'
import FamiliaresComponent from '../../components/expediente/FamiliaresComponent.vue'
import LineaTiempoComponent from '../../components/expediente/LineaTiempoComponent.vue'
import MediaFiliacionComponent from '../../components/expediente/MediaFiliacionComponent.vue'
import CarreraPolicialComponent from '../../components/expediente/CarreraPolicialComponent.vue'
import LocsPersonalMainContainer from '../../components/expediente/locs/LocsPersonalMainContainer.vue'

export default {
  components: {
    PersonalCardComponent,
    MenuListComponent,
    DatosGeneralesComponent,
    DocumentosComponent,
    DesarrolloElementoComponent,
    AreaAdscripcionComponent,
    ReferenciasComponent,
    PuestoDependenciaComponent,
    FaltasAdministrativasComponent,
    FamiliaresComponent,
    LineaTiempoComponent,
    MediaFiliacionComponent,
    CarreraPolicialComponent,
    LocsPersonalMainContainer,
  },

  async mounted() {
    await this.SET_SELECTED_MENU(1)
    this.loadingPersonalData = true
    await this.fetchPersonalById(this.id)
    await this.fetchEstudiosByPersonal(this.id)
    await this.fetchDocumentoByPersonal(this.id)
    await this.fetchEvaluacionMedicaByPersonal(this.id)
    await this.fetchDictamenPersonal(this.id)
    await this.fetchArmasPersonal(this.id)
    await this.fetchBiometricosPersonal(this.id)
    await this.fetchAsignacionEquipoByPersonal(this.id)
    await this.fetchCursosAsignadosByPersonal(this.id)
    await this.fetchProductividad(this.id)
    await this.fetchRespetoPrincipios(this.id)
    await this.fetchReferenciasByPersonal(this.id)
    await this.fetchFaltasAdministrativasByPersonal(this.id)
    await this.fetchFamiliaresByPersonal(this.id)
    await this.fetchPermutacionesByPersonal(this.id)
    await this.fetchEnrolamientoByPersonal(this.id)
    this.loadingPersonalData = false
  },

  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {
      nameRules: [(v) => !!v || 'Este campo es requerido.'],
      loadingPersonalData: false,

      estadoNace: null,
      municipioNace: null,
      estadoRadica: null,
      municipioRadica: null,
      estadoDireccion: null,
      municipioDireccion: null,
      saveChanges: false,

      menuNacimiento: false,
      date: null,
    }
  },

  watch: {
    menuNacimiento(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),

    ...mapGetters('estudio', {
      estudios: 'getEstudios',
    }),

    ...mapGetters('documento', {
      documentos: 'getDocumentos',
    }),

    ...mapGetters('tipoNacionalidad', {
      tipoNacionalidad: 'getTipoNacionalidad',
    }),

    ...mapGetters('municipio', {
      municipios: 'getMunicipios',
    }),

    ...mapGetters('estado', {
      estados: 'getEstados',
    }),

    ...mapGetters('sexo', {
      sexo: 'getSexo',
    }),

    ...mapGetters('armaPersonal', {
      armasPersonal: 'getArmasPersonal',
    }),

    ...mapGetters('biometrico', {
      biometricosPersonal: 'getBiometricosPersonal',
    }),

    ...mapGetters('asignacionEquipo', {
      equipamientoPersonal: 'getAsignacionesEquipo',
    }),

    ...mapGetters('cursoAsignado', {
      cursos: 'getCursosAsignadosPersonal',
    }),

    ...mapGetters('productividad', {
      evaluacionesProductividad: 'getProductividad',
    }),

    ...mapGetters('respetoPrincipios', {
      evaluacionesRespetoPrincipios: 'getRespetoPrincipios',
    }),

    ...mapGetters('expediente', {
      selectedMenu: 'getSelectedMenu',
    }),

    ...mapGetters('evaluacionMedica', {
      evaluacionesMedicas: 'getEvaluacionMedica',
    }),

    ...mapGetters('dictamenPersonal', {
      dictamenes: 'getDictamenPersonal',
    }),

    ...mapGetters('referencias', {
      referencias: 'getReferencias',
    }),

    ...mapGetters('permutacion', {
      permutaciones: 'getPermutaciones',
    }),

    ...mapGetters('faltasAdministrativas', {
      faltasAdministrativas: 'getFaltasAdministrativas',
    }),

    ...mapGetters('familiares', {
      familiares: 'getFamiliares',
    }),

    ...mapGetters('enrolamiento', {
      enrolamiento: 'getEnrolamientos',
    }),

    menu: function () {
      return []
    },

    estudiosPersonal: function () {
      if (this.estudios) {
        return this.estudios.filter((estudio) => {
          return estudio.fk_idPersonal == this.id
        })
      } else return []
    },

    cursosPersonal: function () {
      if (this.cursos) {
        return this.cursos.filter((cursoAsignado) => {
          return cursoAsignado.fk_idPersonal == this.id
        })
      } else return []
    },

    evaluacionesPersonalProductividad: function () {
      if (this.evaluacionesProductividad) {
        return this.evaluacionesProductividad.filter((evaluacion) => {
          return evaluacion.fk_idPersonal == this.id
        })
      } else return []
    },

    evaluacionesPersonalRespetoPrincipios: function () {
      if (this.evaluacionesRespetoPrincipios) {
        return this.evaluacionesRespetoPrincipios.filter((evaluacion) => {
          return evaluacion.fk_idPersonal == this.id
        })
      } else return []
    },
  },

  methods: {
    ...mapActions('comprobanteEstudios', ['fetchComprobantesEstudios']),
    ...mapActions('documento', ['fetchDocumentoByPersonal']),
    ...mapActions('estudio', ['fetchEstudiosByPersonal']),
    ...mapActions('evaluacionMedica', ['fetchEvaluacionMedicaByPersonal']),
    ...mapActions('dictamenPersonal', ['fetchDictamenPersonal']),
    ...mapActions('estatusDocumento', ['updateEstatusDocumento']),
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapActions('armaPersonal', ['fetchArmasPersonal']),
    ...mapActions('biometrico', ['fetchBiometricosPersonal']),
    ...mapActions('asignacionEquipo', ['fetchAsignacionEquipoByPersonal']),
    ...mapActions('cursoAsignado', ['fetchCursosAsignadosByPersonal']),
    ...mapActions('productividad', ['fetchProductividad']),
    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapActions('referencias', ['fetchReferenciasByPersonal']),
    ...mapActions('faltasAdministrativas', ['fetchFaltasAdministrativasByPersonal']),
    ...mapActions('familiares', ['fetchFamiliaresByPersonal']),
    ...mapActions('permutacion', ['fetchPermutacionesByPersonal']),
    ...mapActions('enrolamiento', ['fetchEnrolamientoByPersonal']),
    ...mapMutations('expediente', ['SET_SELECTED_MENU']),

    selectMenu: function (menu) {
      this.selectedMenu = menu
    },

    triggerUpdateEstatusDocumento: async function (documento) {
      await this.updateEstatusDocumento({
        idPersonal: documento.fk_idPersonal,
        idDocumentoPersonal: documento.iddocumentosPersonal,
      })
      await this.fetchDocumentoByPersonal(this.id)
    },

    download: function (url) {
      window.open(url, '_blank')
    },

    downloadQr: function (cuip) {
      window.open('http://ssctlaxcala.eonproduccion.net/qr/?cuip=' + cuip, '_blank')
    },

    triggerUpdatePersonal: async function () {
      var x = this.personal

      if (this.municipioNace) {
        this.personal.fk_idMunicipioNacimiento = this.municipioNace
      }
      if (this.municipioRadica) {
        this.personal.fk_idMunicipioRadica = this.municipioRadica
      }
      if (this.municipioDireccion) {
        this.personal.Contacto.Direccion.fk_idMunicipio = this.municipioDireccion
      }
      await this.updatePersonal(x)
    },

    save(date) {
      this.$refs.menu.save(date)
      this.personal.fechaNacimiento = moment(date).format(this.API_DATE_FORMAT)
    },
  },
}
</script>
